export const colors = [
  '#CC6A62',
  '#62CC6A',
  '#626ACC',
  '#CC9F62',
  '#62CCCC',
  '#CC62A0',
  '#9F62CC',
  '#CC7A62',
  '#62CC88',
  '#627ACC',
  '#CCAA62',
  '#A0CC62',
  '#CC8862',
  '#62CC86',
  '#6286CC',
  '#CC9162',
  '#86CC62',
  '#62CCB0',
  '#B062CC',
  '#CCB062',
  '#62AACC',
  '#AA62CC',
  '#CCAA62',
  '#62CCAA',
  '#AACC62',
  '#CC62AA',
  '#86CCB0',
  '#AACC86',
  '#CCB086',
  '#AA865C',
]
